import "core-js/modules/es.array.map";
import _objectSpread from "E:/work/english/new-evaluation/src/admin/node_modules/@babel/runtime/helpers/esm/objectSpread2";
import { uniqueId } from 'lodash';
/**
 * @description 给菜单数据补充上 path 字段
 * @description https://github.com/d2-projects/d2-admin/issues/209
 * @param {Array} menu 原始的菜单数据
 */

function supplementPath(menu) {
  return menu.map(function (e) {
    return _objectSpread(_objectSpread({}, e), {}, {
      path: e.path || uniqueId('d2-menu-empty-')
    }, e.children ? {
      children: supplementPath(e.children)
    } : {});
  });
}

export var menuHeader = supplementPath([
  /* { path: '/index', title: '首页', icon: 'home' },
  { path: '/grade', title: '年级', icon: 'home' },
  { path: '/paper', title: '试卷', icon: 'home' },
  { path: '', title: '专项训练', icon: 'home' }
    {
    title: '页面',
    icon: 'folder-o',
    children: [
      { path: '/page1', title: '页面 1' },
      { path: '/page2', title: '页面 2' },
      { path: '/page3', title: '页面 3' },
     ]
  } */
]);
export var menuAside = supplementPath([// { path: '/index', title: '首页', icon: 'home' },
{
  title: '基础数据',
  icon: 'database',
  children: [{
    path: '/grade',
    title: '年级',
    icon: ''
  }, {
    path: '/unit',
    title: '单元',
    icon: ''
  }, {
    path: '/mysetting',
    title: '我的设置',
    icon: ''
  }]
}, {
  title: '订单',
  icon: 'database',
  children: [{
    path: '/rate',
    title: '资费',
    icon: ''
  }, {
    path: '/orderinfo',
    title: '订单',
    icon: ''
  }]
}, {
  title: '题库管理',
  icon: 'book',
  children: [{
    path: 'question-bank-list',
    title: '题库列表',
    icon: ''
  }, {
    path: 'question-bank-vocabulary-audio',
    title: '词汇音频',
    icon: ''
  }, {
    path: 'question-bank-quality-stats',
    title: '质量统计',
    icon: ''
  }, {
    path: 'question-bank-qc',
    title: 'QC 质检工作台',
    icon: ''
  }]
}]);